import styled from 'styled-components'

export const FormIdeaSectionName = styled.h4`
  font-size: 1.5rem;
  margin-bottom: 2rem;
`
export const FormIdeaSections = styled.div`
  padding: 1rem 2rem 2rem 2rem;
  height: 100%;
  max-height: 70vh;
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  position: relative;
  ::-webkit-scrollbar-track {
    background-color: var(--white);
  }
  
  section.first-section h3 {
    margin-top: 0.5rem !important;
  }
`

export const FormIdeaHeader = styled.div`
  background-color: #ffffff;
  box-shadow: 0 5px 2px -2px var(--shadow-smooth);
  align-items: center;
  position: -webkit-sticky;
  position: sticky;
  top: 80px;
  z-index: 2;
  padding: 1rem 0;
`

export const HeaderTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const FormIdeaResolverName = styled.h1`
  font-weight: 700;
  font-size: 22px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  @media screen and (min-width: 768px) {
    line-height: 48px;
    margin: 0;
    max-width: 50rem;
    font-size: 28px;
  }
`

export const SectionTitle = styled.h3`
  font-weight: 600;
  font-size: 18px;
  margin: 0;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  color: #212529;
  padding-bottom: 0.5rem;
`

export const SectionDivider = styled.hr`
  border: none;
  border-top: 1px solid #dee2e6;
  margin: 0;
  margin-bottom: 1.5rem;
`

export const SectionContent = styled.div`
  margin-bottom: 1rem;
  min-width: 0;
  max-width: 100%;
  overflow-wrap: break-word;
`